/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { AppService, localStorageDark } from '@alfa-client/app-shared';
import { DOCUMENT } from '@angular/common';
import { Component, OnInit, Renderer2, inject } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'alfa-user-settings-darkmode-container',
  templateUrl: './user-settings-darkmode-container.component.html',
  standalone: false,
})
export class UserSettingsDarkmodeContainerComponent implements OnInit {
  private readonly renderer = inject(Renderer2);
  private readonly appService = inject(AppService);
  private readonly document = inject<Document>(DOCUMENT);

  darkMode$: Observable<boolean>;

  ngOnInit(): void {
    this.darkMode$ = this.appService.getDarkMode();

    this.subscribeToDarkMode();
  }

  private subscribeToDarkMode(): void {
    this.darkMode$.subscribe((darkMode) => (darkMode ? this.addClass(localStorageDark) : this.removeClass(localStorageDark)));
  }

  private addClass(styleClass: string): void {
    this.renderer.addClass(this.document.body, styleClass);
  }

  private removeClass(styleClass: string): void {
    this.renderer.removeClass(this.document.body, styleClass);
  }

  public changeColorMode(darkMode: boolean): void {
    this.appService.setDarkMode(darkMode);
  }
}
